import { Provider } from '@angular/core';
import { CRM_API_URL, resolveCrmApiUrl } from './crm-api.tokens';

export function provideCrmApi(apiUrl: string): Provider[] {
  return [{ provide: CRM_API_URL, useValue: resolveCrmApiUrl(apiUrl) }];
}
